module.exports = __webpack_public_path__ + "img/nbqjc.6423351d.png";